<template>
  <div class="detail-container">
    <div class="control-bar">
      <div class="icon-container">
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/people18/hear-icon.png"
          alt=""
        />
      </div>

      <div class="real-control-container">
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/detail/03play.png"
          alt=""
          class="play-pause-icon"
          @click="() => play()"
          v-if="!playing"
        />
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/detail/03stop.png"
          alt=""
          class="play-pause-icon"
          @click="stop"
          v-else
        />

        <div class="player-inner">
          <div class="bar-container">
            <div class="real-bar-container" @click="onBarTap">
              <div class="bg-bar" ref="bgBar">
                <div class="front-bar" :style="{ width: `${playingPercent}%` }">
                  <div class="ball"></div>
                </div>
              </div>
            </div>
            <div class="times">{{ audioTotalTime }}</div>
          </div>
        </div>
      </div>

      <div class="bts-container">
        <div class="bt-cell" style="background: #a8252a" @click="goBack">
          返&nbsp;回
        </div>
        <div class="bt-cell" @click="showList">列&nbsp;表</div>
        <div class="bt-cell" @click="nextPage">下一页</div>
      </div>
    </div>

    <div class="titles-list nice-scroll" v-show="isShowList">
      <!-- <img
        src="../new-assets/updown.png"
        class="tip-icon"
        alt=""
        v-if="isShowTipIcon"
      /> -->
      <div
        class="title-container"
        v-for="(t, i) in titlesList"
        :key="i"
        @click="onListSelect(i)"
      >
        {{ t }}
      </div>
    </div>

    <audio src="" ref="audio" @timeupdate="onPlaying"></audio>

    <div class="content-container">
      <div class="title-line">
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/detail/03logo.png"
          class="logo"
          alt=""
        />
        <div class="title-text">{{ titlesList[activeIndex] }}</div>
      </div>
      <div class="main-part nice-scroll" v-html="detailList[activeIndex]"></div>
    </div>

    <div class="dialog-container" v-if="isShowDetail">
      <div class="dialog-inner">
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/detail/close.png"
          alt=""
          class="close-img"
          @click="isShowDetail = false"
        />
        <div class="dialog-inner-2">
          <img :src="giftDetailList[activeIndex]" alt="" />
        </div>
      </div>
    </div>

    <img
      :src="giftList[activeIndex]"
      class="gift-img"
      alt=""
      @click="_add(activeIndex)"
      v-if="!has(activeIndex)"
    />
  </div>
</template>

<script >
const detailList = require("../xia.json");

export default {
  props: {
    next: Function,
    back: Function,
  },

  data() {
    return {
      playing: false,
      playingPercent: 0,
      audioTotalTime: "00",

      audioList: [
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (1).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (2).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (3).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (4).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (5).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (6).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (7).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (8).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (9).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (10).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (11).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (12).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (13).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (14).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (15).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (16).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (17).mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/long/longmusic (18).mp3",
      ],

      titlesList: [
        "名副其实！江苏这两个名叫“小康”的村子，就这样“奔小康”",
        "小小楼道长，三种“武器”重聚人心",
        "从“小披屋”到大平层！祖孙三代人用八十载圆了安居梦",
        "傍上黑科技的小番茄为什么这样“红”？",
        "九华，“经济薄弱村”转身为“全国文明村”",
        "先富起来的“李箍桶”，而今遇“幸福的烦恼”",
        "兴化藕农的一次意外发现，凭什么引得央视关注",
        "换个方式“浪里漂”",
        "苏北“穷壳村”飞出的电影原型，定下这个小目标",
        "从湖心到岸上，他守护他们三十载",
        "费孝通曾关注的她，而今涅槃重生",
        "守住“精气神”，乡村有了魂",
        "这些现象级网红，为这座山海之城打造了一张新名片",
        "“宝宝们进来！‘新晋网红’柞水木耳了解一下”",
        "扶贫路，医者心！海拔2700米的守护",
        "“草原大衣哥”，同是援疆人方式却别样！",
        "5年3次进藏，只因学生眼里“闪着光”",
        "跨越1500公里的牵手帮扶，让“不可能”变为现实",
      ],

      giftList: [
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (1).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (2).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (3).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (4).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (5).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (7).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (8).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (9).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (10).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (11).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (12).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (13).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (14).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (15).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (16).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (6).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (17).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/people18/gift (18).png",
      ],

      giftDetailList: [
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (1).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (2).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (3).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (4).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (5).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (7).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (8).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (9).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (10).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (11).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (12).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (13).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (14).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (15).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (16).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (6).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (17).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (18).png",
      ],

      activeIndex: 0,
      isShowList: false,

      isShowDetail: false,

      isShowTipIcon: true,

      detailList,
    };
  },
  mounted() {
    this.activeIndex = this.$store.state.activeIndexPub;
    this.play(this.audioList[this.activeIndex]);
    this.$nextTick(this.bindVideo);
  },
  watch: {
    activeIndex() {
      this.$store.commit("changeActiveIndexPub", this.activeIndex);
    },
  },
  methods: {
    play(src) {
      const audioInstance = this.$refs.audio;
      if (src) {
        audioInstance.src = src;
      }
      this.stopVideo();
      audioInstance.play();
      this.playing = true;
    },

    stop() {
      const audioInstance = this.$refs.audio;
      audioInstance.pause();
      this.playing = false;
    },

    onPlaying(a) {
      const audioInstance = this.$refs.audio;
      if (!audioInstance) return;
      const dur = audioInstance.duration;
      const now = audioInstance.currentTime;
      if (!dur || !now) return;

      // this.audioTotalTime = Math.floor(dur).toString();
      const _audioTotalTime = Math.floor(dur);
      const min = Math.floor(_audioTotalTime / 60);
      const sec = _audioTotalTime % 60;
      this.audioTotalTime = `${min}:${sec}`;

      this.playingPercent = (100 * now) / dur;
    },

    goBack() {
      this.back && this.back();
    },

    nextPage() {
      this.next && this.next();
    },

    onListSelect(i) {
      this.activeIndex = i;
      this.play(this.audioList[this.activeIndex]);
      this.isShowList = false;
      this.$nextTick(this.bindVideo);
    },

    onBarTap(e) {
      const clientX = e.clientX;
      const bgRect = this.$refs.bgBar.getBoundingClientRect();

      const durLength = clientX - bgRect.left;
      const durPercent = durLength / bgRect.width;

      const audioInstance = this.$refs.audio;
      if (!audioInstance) return;
      const dur = audioInstance.duration;
      const shoundNow = dur * durPercent;
      audioInstance.currentTime = shoundNow;
    },

    has(i) {
      return this.$store.state.hasGiftList.includes(i);
    },

    add(i) {
      if (this.has(i)) return;
      this.$store.commit("addHasGiftList", i);
    },

    _add(i) {
      this.add(i);
      this.isShowDetail = true;
      this.isShowList = false;
    },

    bindVideo() {
      let videos = document.getElementsByTagName("video");
      for (let i = 0; i < videos.length; i++) {
        videos[i].addEventListener("playing", this.stop);
      }
    },

    stopVideo() {
      let videos = document.getElementsByTagName("video");
      for (let i = 0; i < videos.length; i++) {
        videos[i].pause();
      }
    },

    showList() {
      this.isShowList = !this.isShowList;
      if (this.isShowTipIcon) {
        setTimeout(() => {
          this.isShowTipIcon = false;
        }, 3000);
      }
    },
  },
};
</script>



<style lang="less" scoped>
@control-bar-width: 15vh;

.detail-container {
  width: 100vw;
  height: 100vh;
  background-image: url("https://jcdn.xhby.net/project/xiaokang/assets/detail/03bg.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;

  .control-bar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: @control-bar-width;
    background: #c23439;
    display: flex;
    justify-content: center;

    .icon-container {
      width: @control-bar-width;
      height: 100%;
      border-right: 1px solid white;
      display: flex;
      align-items: center;

      img {
        width: 80%;
      }
    }

    .real-control-container {
      width: @control-bar-width * 5.5;
      display: flex;
      align-items: center;
      padding-left: 20px;

      .play-pause-icon {
        width: @control-bar-width * 0.4;
        cursor: pointer;
      }

      .player-inner {
        flex: 1;
        height: 100%;
        margin-left: 20px;
        display: flex;
        flex-direction: column;

        .bar-container {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 10px;

          .real-bar-container {
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;

            .bg-bar {
              height: 1px;
              width: 100%;
              background: #fa6368;
              cursor: pointer;

              .front-bar {
                height: 100%;
                background: white;
                position: relative;

                .ball {
                  width: 4px;
                  height: 4px;
                  background: white;
                  border-radius: 50%;
                  position: absolute;
                  right: -2px;
                  top: -2px;
                  transform: translateY(0.5px);
                }
              }
            }
          }

          .times {
            color: #f26166;
            margin-left: 5px;
          }
        }
      }
    }

    .bts-container {
      height: 100%;
      display: flex;
      margin-left: 20px;

      .bt-cell {
        padding: 0 40px;
        cursor: pointer;
        font-size: 20px;
        letter-spacing: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        border-right: 1px solid #cc575c;
      }
    }
  }

  .titles-list {
    position: absolute;
    top: 4vh;
    bottom: @control-bar-width * 1.2;
    right: 20vw;
    width: 40vw;
    background: #ffeccb;
    padding: 10px;
    overflow: auto;
    z-index: 200;
    animation: showFromOp0 0.4s forwards;

    .tip-icon {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 15vh;
    }

    .title-container {
      padding: 10px;
      border-bottom: 1px solid #bcaf96;
      font-size: 18px;
      line-height: 22px;
      cursor: pointer;
    }
  }

  .content-container {
    width: 100%;
    height: calc(100% - @control-bar-width - 8px);
    display: flex;
    flex-direction: column;

    .title-line {
      width: 100%;
      height: 15vh;
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      .logo {
        height: 80%;
        margin-right: 40px;
      }

      .title-text {
        font-size: 30px;
        font-weight: 700;
      }
    }

    .main-part {
      overflow: auto;
      // padding: 0 80px;
      width: 1200px;
      padding-right: 20px;
      margin: 0 auto;
    }
  }

  .gift-img {
    position: absolute;
    right: 10vh;
    bottom: 15vh;
    width: 12vh;
    animation: float 5s infinite linear;
    cursor: pointer;
  }

  .dialog-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;

    .dialog-inner {
      width: 620px;
      height: 400px;
      border: 10px solid #ffeccb;
      background: white;
      position: relative;

      .close-img {
        position: absolute;
        width: 60px;
        top: -30px;
        right: -30px;
        cursor: pointer;
      }

      .dialog-inner-2 {
        width: 100%;
        height: 100%;
        border: 1px dashed #c56f6f;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          height: 80%;
        }
      }
    }
  }
}

@keyframes showFromOp0 {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes float {
  from {
    transform: translateY(-30%);
  }

  50% {
    transform: translateY(0);
  }

  to {
    transform: translateY(-30%);
  }
}
</style>

<style lang="less">
.main-part {
  flex: 1;
  overflow: auto;
  text-align: justify;

  .title {
    font-family: "宋体";
    font-size: 15px;
    color: #2f2f2f;
    font-weight: bold;

    display: none;
  }
  .start-txt {
    display: flex;
    justify-content: space-between;
    // align-items: flex-start;
    align-items: center;
  }
  .start-video {
    width: 100%;
    object-fit: contain;
    margin-top: 14px;
  }
  p {
    text-indent: 2em;
    line-height: 26px;
    margin: 22px auto;
    font-family: "宋体";
    font-size: 18px;
    color: #2f2f2f;
  }
  .figure-pic {
    text-indent: 0;
    text-align: center;
    margin-bottom: 5px;
  }
  .figure-txt {
    text-indent: 0;
    margin-left: 8%;
    margin-top: 0;
    font-family: "楷体";
    font-size: 13px;
  }
  img {
    width: 85%;
  }
  .story {
    text-indent: 0;
    text-align: center;
    color: #b9222a;
  }
  .story-span {
    font-family: "微软雅黑";
    font-size: 11px;
    background-color: #ffecca;
    padding: 2px 10px;
  }
  .dictate-title {
    text-indent: 0;
    text-align: center;
    font-weight: bold;
  }
  .dictate-txt {
    font-weight: bold;
  }
  .wish-ext-box {
    width: 70%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15%;
    margin-top: 50px;
    background-color: #ffecca;
  }
  .wish-in-box {
    width: 100%;
    margin: 15px;
    background-color: #ffffff;
    border: #be585b;
    border-width: 1px;
    border-style: dotted;
    padding: 0 20px;
  }
  .over {
    text-indent: 0;
    font-family: "楷体";
    font-size: 13px;
    margin-left: 43%;
  }
}
</style>